/**
 * Helpers for the `federatedInstances` localStorage cache, a map keyed by the
 * federated agency route (`/federated/{instanceId}/{agencyId}`) → `{ name,
 * instanceName, updatedOn }`. Centralizes the read/write/parse so the cache
 * shape lives in one place instead of being hand-rolled across pages and stores.
 */
const KEY = "federatedInstances";

/** Reads the whole cache, returning an empty object on missing/corrupt data. */
export const readFederatedCache = () => {
  try {
    return JSON.parse(window.localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

/** Merges `entry` into the cache under `cacheKey` and returns the merged entry. */
export const writeFederatedCacheEntry = (cacheKey, entry) => {
  const cache = readFederatedCache();
  cache[cacheKey] = { ...cache[cacheKey], ...entry };
  window.localStorage.setItem(KEY, JSON.stringify(cache));
  return cache[cacheKey];
};

/** Removes a single entry from the cache. */
export const deleteFederatedCacheEntry = (cacheKey) => {
  const cache = readFederatedCache();
  delete cache[cacheKey];
  window.localStorage.setItem(KEY, JSON.stringify(cache));
};

/** Clears the whole cache (e.g. on logout). */
export const clearFederatedCache = () => {
  window.localStorage.removeItem(KEY);
};
